module.exports = __webpack_public_path__ + "7e6549f9ce3d2f0569d726c808b43da5.png";